import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ColorsQuery } from 'src/app/services/akita/colors.query';

/**
 * Mirrors the runtime theme (colors API → ColorsQuery) into CSS custom
 * properties on <html>, so new components can style with var(--pca-*)
 * instead of threading [style.*] bindings through every element.
 * Index order matches every existing consumer: primary, primaryLight,
 * background, text.
 */
@Injectable({ providedIn: 'root' })
export class ThemeVarsService {
  private started = false;

  constructor(private colorsQuery: ColorsQuery, @Inject(DOCUMENT) private document: Document) {}

  start(): void {
    if (this.started) { return; }
    this.started = true;

    this.colorsQuery.selectAll().subscribe(colors => {
      if (colors.length < 4) { return; }
      const style = this.document.documentElement.style;
      style.setProperty('--pca-primary', colors[0].toString());
      style.setProperty('--pca-primary-light', colors[1].toString());
      style.setProperty('--pca-bg', colors[2].toString());
      style.setProperty('--pca-text', colors[3].toString());
    });
  }
}
